<template>
  <div>
    <h5 class="mb-0">{{ getDrawerText(shift) }}</h5>
    <small class="text-muted">{{ getStartedAtText(shift) }}</small>
    <template v-if="!isDrawerOpen(shift)">
    
    <small class="text-muted"> | {{ getEndedAtText(shift) }}</small>
    </template>
  </div>
</template>

<script>

import Drawer from "@/mixins/account/Drawer"

export default {
  props: {
    shift: {},
  },

  mixins : [ Drawer ],
};
</script>

<style>
</style>